import isBrowser from 'utils/is-browser';

export default function isMacLike() {
    return isBrowser() ? /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform) : null;
}
